module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-engagements-icon-100-natural-ingredients.d795cf9b.svg";